export default __webpack_public_path__ + "static/media/Stave of Malefic Rites.c1f2b51e.jpg";